export default __webpack_public_path__ + "static/media/blend-concerns.67fa65f6.svg";